"use strict";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.EraBasedValue = void 0;
const ethers_1 = require("ethers");
class EraBasedValue {
    constructor(era, value, valueAfter, delay = 1) {
        this.era = era;
        this.value = ethers_1.ethers.BigNumber.from(value);
        this.valueAfter = ethers_1.ethers.BigNumber.from(valueAfter);
        this._delay = delay;
    }
    getValue(currentEra) {
        return currentEra >= this.era + this._delay ? this.valueAfter : this.value;
    }
}
exports.EraBasedValue = EraBasedValue;
//# sourceMappingURL=common.js.map